import React, { useState, useEffect, useRef } from "react";
import { MdClose } from "react-icons/md";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { Box, Button, Flex, Text, Image } from "@chakra-ui/react";
import { IoIosArrowDown } from "react-icons/io";
import { AnimatePresence, motion } from "framer-motion";
import { headers } from "../components/common/constants";
import { scroller } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";

const Menu = ({ isOpen, onClose }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const drawerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (item, subItem) => {
    const targetPath = subItem.path.toLowerCase();
    if (item.name === "About Us") {
      if (window.location.pathname !== "/about-us") {
        navigate("/about-us", { state: { section: targetPath } });
      } else {
        scrollToSection(targetPath);
      }
    } else if (item.name === "Services") {
      if (window.location.pathname !== "/services") {
        navigate("/services", { state: { section: targetPath } });
      } else {
        scrollToSection(targetPath);
      }
    } else {
      navigate(targetPath);
    }
    onClose();
  };

  const scrollToSection = (sectionId, retryCount = 5) => {
    const element = document.getElementById(sectionId);
    if (element) {
      scroller.scrollTo(sectionId, {
        duration: 800,
        smooth: "easeInOutQuart",
        offset: -80,
      });
    } else if (retryCount > 0) {
      setTimeout(() => scrollToSection(sectionId, retryCount - 1), 500);
    }
  };

  useEffect(() => {
    if (!isOpen) setOpenIndex(null);
  }, [isOpen]);

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      direction="right"
      style={{
        width: "min(88vw, 380px)",
        background:
          "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
      }}
    >
      <Box p="22px" ref={drawerRef} h="100vh" overflowY="auto">
        <Flex justifyContent="space-between" align="center" mb="30px">
          <Image src="/assets/logo.png" alt="TransAlliance Capital" w="140px" h="30px" objectFit="contain" />
          <Box
            as="button"
            onClick={onClose}
            p="8px"
            borderRadius="10px"
            bg="slate.100"
            _hover={{ bg: "slate.200" }}
          >
            <MdClose size="22px" />
          </Box>
        </Flex>

        <Flex flexDir="column" gap="6px">
          {headers.map((item, i) => {
            const isActive = location.pathname === item?.path;
            const expanded = openIndex === i;
            return (
              <Box key={i}>
                <Flex
                  as={motion.div}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: i * 0.05 }}
                  align="center"
                  justify="space-between"
                  px="16px"
                  py="14px"
                  borderRadius="12px"
                  bg={isActive ? "brand.50" : "transparent"}
                  cursor="pointer"
                  onClick={() => {
                    if (item.sub) {
                      setOpenIndex(expanded ? null : i);
                    } else {
                      navigate(item.path);
                      onClose();
                    }
                  }}
                  _hover={{ bg: "slate.100" }}
                  sx={{ transition: "background-color .2s ease" }}
                >
                  <Text
                    fontSize="16px"
                    fontWeight={isActive ? 700 : 600}
                    color={isActive ? "brand.600" : "ink"}
                  >
                    {item.name}
                  </Text>
                  {item?.sub && (
                    <motion.div
                      animate={{ rotate: expanded ? 180 : 0 }}
                      transition={{ duration: 0.2 }}
                    >
                      <IoIosArrowDown color="#64748B" />
                    </motion.div>
                  )}
                </Flex>

                <AnimatePresence>
                  {item.sub && expanded && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      style={{ overflow: "hidden" }}
                    >
                      <Flex flexDir="column" pl="18px" py="6px" gap="2px">
                        {item.sub.map((subItem, subIndex) => (
                          <Box
                            key={subIndex}
                            onClick={() => handleNavigation(item, subItem)}
                            px="14px"
                            py="10px"
                            borderRadius="10px"
                            fontSize="14.5px"
                            fontWeight={500}
                            color="slate.600"
                            cursor="pointer"
                            borderLeft="2px solid"
                            borderColor="slate.200"
                            _hover={{
                              color: "brand.600",
                              borderColor: "brand.500",
                              bg: "brand.50",
                            }}
                            transition="all .2s"
                          >
                            {subItem.name}
                          </Box>
                        ))}
                      </Flex>
                    </motion.div>
                  )}
                </AnimatePresence>
              </Box>
            );
          })}
        </Flex>

        <Button
          mt="30px"
          w="full"
          h="52px"
          fontSize="15px"
          onClick={() => {
            navigate("/contact-us");
            onClose();
          }}
        >
          Get in touch
        </Button>

        <Box mt="40px" p="18px" borderRadius="14px" bg="brand.50">
          <Text fontSize="12px" fontWeight={700} color="brand.600" letterSpacing="wide" textTransform="uppercase">
            Reach us
          </Text>
          <Text mt="8px" fontSize="14px" color="slate.700">
            info@transalliancecapital.ng
          </Text>
          <Text fontSize="14px" color="slate.700">
            No 200c Muri Okunola St, VI Lagos
          </Text>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Menu;
